import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ConfirmModal from './ConfirmModal';

export default function Bottling({ setPage }) {
  const [bulkStocks, setBulkStocks] = useState([]);
  const [bottles, setBottles] = useState([]);
  const [form, setForm] = useState({ bulk_stock_id:'', bottle_material_id:'', bottle_size_ml:'30', qty_bottles_planned:'', qty_bottles_actual:'', loss_ml:'0', notes:'' });
  const [confirm, setConfirm] = useState(false);
  const [success, setSuccess] = useState(false);
  const [msg, setMsg] = useState('');
  const [history, setHistory] = useState([]);

  useEffect(() => {
    axios.get('/api/bulk-stock').then(r => setBulkStocks(r.data)).catch(()=>{});
    axios.get('/api/materials').then(r => setBottles(r.data.filter(m=>m.category==='packaging')));
    axios.get('/api/bottling').then(r => setHistory(r.data));
  }, []);

  const setF = (k,v) => setForm(f=>({...f,[k]:v}));
  const totalMl = ((parseInt(form.qty_bottles_actual||form.qty_bottles_planned)||0)*parseFloat(form.bottle_size_ml||0)+(parseFloat(form.loss_ml)||0));
  const kgUsed = (totalMl/1000*0.95).toFixed(4);

  const handleSubmit = async () => {
    try {
      await axios.post('/api/bottling', form);
      setSuccess(true);
      setForm({ bulk_stock_id:'', bottle_material_id:'', bottle_size_ml:'30', qty_bottles_planned:'', qty_bottles_actual:'', loss_ml:'0', notes:'' });
      axios.get('/api/bottling').then(r => setHistory(r.data));
    } catch (err) {
      setMsg(err.response?.data?.error || 'เกิดข้อผิดพลาด');
    }
    setConfirm(false);
  };

  return (
    <div>
      {confirm && <ConfirmModal title="ยืนยันบรรจุขวด" body={`ยืนยันการบรรจุ ${form.qty_bottles_actual||form.qty_bottles_planned} ขวด × ${form.bottle_size_ml} ml (ใช้ Bulk ≈ ${kgUsed} kg)?`} onConfirm={handleSubmit} onCancel={() => setConfirm(false)}/>}
      {msg && <div className="alert alert-danger">{msg}</div>}
      {success && (
        <div className="success-banner">
          <span><i className="ti ti-check" style={{ marginRight:6 }}/>บรรจุขวดสำเร็จ</span>
          <button className="btn-primary" style={{ fontSize:11,padding:'5px 14px' }} onClick={() => { setSuccess(false); setPage('finished-stock'); }}>
            ดูสต็อก Finished →
          </button>
        </div>
      )}

      <div className="sh">บรรจุขวด</div>
      <div className="glass-card">
        <div className="grid-2">
          <div className="form-group">
            <label className="fl">เลือก Batch Bulk</label>
            <select className="fi" value={form.bulk_stock_id} onChange={e => setF('bulk_stock_id',e.target.value)}>
              <option value="">เลือก batch...</option>
              {bulkStocks.map(b => <option key={b.id} value={b.id}>{b.batch_no} · {b.formula_name} ({parseFloat(b.qty_kg).toFixed(2)} kg)</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="fl">ขวด/บรรจุภัณฑ์</label>
            <select className="fi" value={form.bottle_material_id} onChange={e => setF('bottle_material_id',e.target.value)}>
              <option value="">เลือกขวด...</option>
              {bottles.map(b => <option key={b.id} value={b.id}>{b.name} (สต็อก: {parseFloat(b.stock_qty).toFixed(0)} {b.unit})</option>)}
            </select>
          </div>
          <div className="form-group"><label className="fl">ขนาดขวด (ml)</label><input className="fi" type="number" value={form.bottle_size_ml} onChange={e => setF('bottle_size_ml',e.target.value)}/></div>
          <div className="form-group"><label className="fl">จำนวนที่วางแผน (ขวด)</label><input className="fi" type="number" value={form.qty_bottles_planned} onChange={e => setF('qty_bottles_planned',e.target.value)}/></div>
          <div className="form-group"><label className="fl">บรรจุได้จริง (ขวด)</label><input className="fi" type="number" value={form.qty_bottles_actual} onChange={e => setF('qty_bottles_actual',e.target.value)} placeholder={form.qty_bottles_planned}/></div>
          <div className="form-group"><label className="fl">Loss (ml)</label><input className="fi" type="number" value={form.loss_ml} onChange={e => setF('loss_ml',e.target.value)}/></div>
        </div>

        {form.qty_bottles_planned && (
          <div className="loss-box">
            <i className="ti ti-droplet"/>
            {form.qty_bottles_actual||form.qty_bottles_planned} ขวด × {form.bottle_size_ml} ml + Loss {form.loss_ml} ml = {totalMl.toFixed(0)} ml ≈ {kgUsed} kg
          </div>
        )}

        <div className="form-group" style={{ marginTop:12 }}>
          <label className="fl">หมายเหตุ</label>
          <input className="fi" value={form.notes} onChange={e => setF('notes',e.target.value)} placeholder="หมายเหตุ"/>
        </div>
        <div className="btn-row">
          <button className="btn-primary" disabled={!form.bulk_stock_id||!form.bottle_material_id||!form.qty_bottles_planned} onClick={() => setConfirm(true)}>
            ยืนยันบรรจุขวด
          </button>
        </div>
      </div>

      <div className="sh">ประวัติการบรรจุ</div>
      <div className="glass-card">
        <table className="tbl">
          <thead><tr><th>สูตร</th><th>ขวด</th><th>ขนาด</th><th>บรรจุ</th><th>Loss (ml)</th><th>โดย</th><th>วันที่</th></tr></thead>
          <tbody>
            {history.map(h => (
              <tr key={h.id}>
                <td style={{ fontWeight:500 }}>{h.formula_name}</td>
                <td>{h.bottle_name}</td>
                <td>{h.bottle_size_ml} ml</td>
                <td style={{ fontWeight:600 }}>{h.qty_bottles_actual||h.qty_bottles_planned} ขวด</td>
                <td>{parseFloat(h.loss_ml||0).toFixed(2)}</td>
                <td>{h.created_by_name}</td>
                <td>{new Date(h.created_at).toLocaleDateString('th-TH')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
